module.exports = __webpack_public_path__ + "static/media/ic_player_fullscreen_close.84cb8231.svg";